import styled from "styled-components";
import Header from "../components/header/Header";
import SettingsContent from "../components/bookings_manager/settings/content/SettingsContent";
import { useNavigate } from "react-router-dom";
import "react-toggle/style.css"; 

//------------------------------------------------------------------------

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
`;

//------------------------------------------------------------------------

const Settings = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <Header
        text={"Settings"}
        redirectFn={() => {
          navigate("/home");
        }}
      />
      <ContentContainer>
        <SettingsContent />
      </ContentContainer>
    </Container>
  );
};

export default Settings;
